import React, { useContext, useState } from "react";
import DropTarget from "./DropTarget";
import { IonItem, IonGrid, IonRow, IonCol, IonButtons, IonButton, IonIcon, IonLabel, IonText, IonReorderGroup, IonReorder, IonChip } from "@ionic/react";
import { closeCircleOutline, appsOutline } from 'ionicons/icons';
import { Question } from "models/questionnaire.model";
import RemoveAlert from "../UI/RemoveAlert";
import { getIconById } from "misc/utils";
import { UIElementEnum } from "models/ui-element.enum";
import HTMLReactParser from "html-react-parser";
import './DropList.scss'
import { AppContext } from "context/app.context";

const Droplist = (props: {
    reorder: boolean,
    sectionID: number,
    cols: number,
    items: Question[],
    onItemDropped: (item: any, type: any, index: number) => void,
    onItemDeleted: (item: Question, sectionIndex: number) => void,
    onMoveItem: (e: any, sectionID: number) => void,
    onItemClicked: (item: Question) => void
}) => {

    const { helpMode } = useContext(AppContext)
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteItemIdx, setDeleteItemIdx] = useState(0);
    const [selectedQ, setSelectedQ] = useState(0);

    const itemDropped = (item: any, type: any) => {
        setSelectedQ(item.QuestionID);
        props.onItemDropped(JSON.parse(item), type, props.sectionID);
    }

    const itemClicked = (item: Question) => {
        setSelectedQ(item.QuestionID);
        props.onItemClicked(item);
    }

    const onDelete = (e:any, idx:number) => {
        setShowDeleteAlert(true); 
        setDeleteItemIdx(idx);
        e.stopPropagation();
    } 
    
    const confirmDelete = () => {
        const item = props.items[deleteItemIdx];
        props.onItemDeleted(item, props.sectionID);
        setSelectedQ(0);
    }

    const getFlairText = (meta: any) => {
        const metaJson = JSON.parse(meta);
        switch(metaJson.Table) {
            case "HealthIssueType": return `${metaJson.Schema.HealthIssueTypeID} ${metaJson.Schema.Description}`;
            case "ProcAttribType": return metaJson.Schema.Name;
            default: return "";
        }
    }

    const metaJSON = (meta: any) => {
        return JSON.parse(meta);
    }
    
    if(props.reorder) {
        return (
            <IonReorderGroup key="reorderQuestions" disabled={false} onIonItemReorder={(e) => { props.onMoveItem(e, props.sectionID); }}>
                {props.items.map((item, index) => {
                    return (
                        <IonItem key={item.QuestionID} className={`pointer ${item.QuestionID === selectedQ && 'highlighted-item'}`}>
                            <IonReorder slot="start">
                                <IonIcon icon={appsOutline} />
                            </IonReorder>
                            <IonIcon color='primary' icon={getIconById(item.UIElementID)} />
                            <IonLabel className="ml-1" title={item.Label}>
                                {item.IsRequired && <span className="is-required">*</span>}
                                <IonText className={`ion-text-wrap ${item.IsLabelHidden && 'text-muted'}`}>{item.Label}</IonText> 
                            </IonLabel>
                            <IonButtons slot="end" className="ion-no-margin">
                                <IonButton onClick={e => onDelete(e, index)}>
                                    <IonIcon color='danger' slot="icon-only" icon={closeCircleOutline} />
                                </IonButton>
                            </IonButtons>
                        </IonItem>
                    )}
                )}
                <RemoveAlert isOpen={showDeleteAlert} onCancel={() => setShowDeleteAlert(false)} onDelete={confirmDelete} />
            </IonReorderGroup>
        )
    }

    return (
        <DropTarget onItemDropped={itemDropped} dropEffect="all">
            {props.items && props.items.length === 0 
            ? <p className="align-self-center"><b>Drag n drop items from TOOLBOX onto here</b></p>
            : <IonGrid className="ion-no-padding">
                    <IonRow className="ion-no-padding">
                        {(props.items).map((item, index) => {
                            return (
                                <IonCol key={item.QuestionID} size={(12/(item.ColSpan || props.cols)).toString()}>
                                    <IonItem className={`pointer ${item.QuestionID === selectedQ && 'highlighted-item'}`} onClick={() => itemClicked(item)}>
                                        <IonButtons>
                                            <IonButton>
                                                <IonIcon color='primary' slot="icon-only" icon={getIconById(item.UIElementID)} />
                                            </IonButton>
                                        </IonButtons>

                                        <div className="d-flex flex-column">
                                            <IonLabel key={item.QuestionID} className="item ion-no-margin ion-text-wrap" title={item.Label}>
                                                {item.IsRequired && <span className="is-required">*</span>}
                                                <IonText className={item.IsLabelHidden ? 'text-muted':''}>
                                                    {item.UIElementID === UIElementEnum.pa ? HTMLReactParser(item.Label) : item.Label}
                                                </IonText>
                                            </IonLabel>
                                            {helpMode && metaJSON(item.Meta)?.Schema?.hasOwnProperty('ParentID') && 
                                                <IonChip color="success" className="question-flair">
                                                    {getFlairText(item.Meta)}
                                                </IonChip>
                                            }
                                        </div>

                                        <IonButtons slot="end" className="ion-no-margin">
                                            <IonButton onClick={e => onDelete(e, index)}>
                                                <IonIcon color='danger' slot="icon-only" icon={closeCircleOutline} />
                                            </IonButton>
                                        </IonButtons>
                                    </IonItem>
                                </IonCol>
                            )
                        }
                    )}
                    </IonRow>
                </IonGrid>
            }             
            <RemoveAlert isOpen={showDeleteAlert} onCancel={() => setShowDeleteAlert(false)} onDelete={confirmDelete} />
        </DropTarget>
    )
};

export default Droplist;
